import type { ReactNode } from "react";

type Props = { children: ReactNode; delay?: number; className?: string; y?: number };

// Kept as a lightweight wrapper. No scroll observer or animation library is used.
export default function Reveal({ children, className = "" }: Props) {
  return <div className={className}>{children}</div>;
}
